import React from 'react'
import NewCoinMarket from '../Home/NewCoinMarket'
import { Typography } from '@mui/material'

const StartTrading = () => {
  return (
    <div style={{marginTop: '75px'}}>
        <Typography mb={1}  ml={3} mt={4} sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase', textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                TRADE SUPPORTED ASSETS
        </Typography>
        <Typography  sx={{textAlign: 'center'}} variant="body2" color="text.secondary">
                kindly click any asset pair to trade
        </Typography>
      <NewCoinMarket/>
    </div>
  )
}

export default StartTrading
